<template>
	<div class="sign_wrap">
		<!-- 注册头部 -->
		<div class="sign_top">
			<div class="email">
				<span class="circle">1</span>验证邮箱
			</div>
			<div class="phone" :class="{phone_await: isPhoneAwait}">
				<span class="circle" :class="{circle_await: isPhoneAwait}">2</span>验证手机
			</div>
			<div class="password" :class="{password_await: isPasswordAwait}">
				<span class="circle" :class="{circle_await: isPasswordAwait}">3</span>设置密码
			</div>
			<div class="done" :class="{done_await: isDoneAwait}">
				<span class="circle" :class="{circle_await: isDoneAwait}">4</span>注册完成
			</div>
		</div>
		<!-- 注册表单 -->
		<div class="sign_info">
			<!-- 验证邮箱 -->
			<el-form v-show="isEmail" :model="emailForm" ref="emailForm" label-width="100px" class="demo-dynamic">
			  <el-form-item prop="email" label="邮箱:"
			    :rules="[
			      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
			      { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
			    ]">
			    <el-input autofocus v-model="emailForm.email" placeholder="输入邮箱，作为登录大V服务平台的登录账号"></el-input>
			  </el-form-item>
			  <el-form-item label-width="100px">
			    <el-button type="primary" :disabled="isCode || !emailForm.email" @click="submitIcode(0,emailForm.email)">
			    		{{ btnTxt }}
			    	</el-button>
			    <!-- <el-button v-if="isCode" type="primary" :disabled="true">60</el-button> -->
			  </el-form-item>
			  <el-form-item label="验证码:" prop="icode"
			    :rules="{
			      required: true, message: '验证码不能为空', trigger: 'blur'
			    }">
			    <el-input v-model="emailForm.icode" placeholder="请输入您的验证码"></el-input>
			  </el-form-item>
			  <el-form-item label-width="100px">
			    <el-button type="primary" :disabled="!emailForm.icode" @click="submitEmail('emailForm')">验证邮箱</el-button>
			  </el-form-item>
			</el-form>
			<div class="tip_wrod main_word" v-if="isTip">
				<p>验证邮件已发送到邮箱</p>
				<p>若收件箱未收到，请检查垃圾箱是否有新邮件。</p>
				<p>如未收到，可再次点击<span class="main_word">[发送验证码]</span>获取验证连接。</p>
			</div>

			<!-- 验证手机 -->
			<el-form v-show="isPhone" :model="phoneForm" :rules="rules2" ref="phoneForm" label-width="100px" class="demo-ruleForm">
			  <el-form-item label="手机号:" prop="phone">
			    <el-input class="getfocus" v-model="phoneForm.phone" placeholder="输入手机号，作为登录大V服务平台的登录账号"></el-input>
			  </el-form-item>
			  <el-form-item label-width="100px">
			    <el-button type="primary" :disabled="isCode || !phoneForm.phone" @click="submitIcode(1,phoneForm.phone)">
			    	{{ btnTxt }}
			    </el-button>
			    <!-- <el-button v-if="isCode" type="primary" :disabled="true">60</el-button> -->
			  </el-form-item>
			  <el-form-item label="验证码:" prop="icode"
			    :rules="{
			      required: true, message: '验证码不能为空', trigger: 'blur'
			    }">
			    <el-input v-model="phoneForm.icode" placeholder="输入手机收到的大V店验证码"></el-input>
			  </el-form-item>
			  <el-form-item label-width="100px">
			    <el-button type="primary" :disabled="!phoneForm.icode" @click="submitPhone('phoneForm')">验证手机</el-button>
			  </el-form-item>
			</el-form>

			<!-- 验证密码 -->
			<el-form v-show="isPass" :model="passForm" :rules="rules" ref="passForm" label-width="100px" class="demo-ruleForm">
			  <el-form-item label="密码" prop="pass">
			    <el-input type="password" v-model="passForm.pass" auto-complete="off" 
			    					placeholder="请输入您的登录密码，8~20位数字和字母组合">
			    </el-input>
			  </el-form-item>
			  <span class="pass_tip">8-20位字母和数字组合</span>
			  <el-form-item label="确认密码" prop="checkPass">
			    <el-input type="password" v-model="passForm.checkPass" auto-complete="off" placeholder="请再次输入您的登录密码">
			    </el-input>
			  </el-form-item>
			  <el-form-item label-width="100px">
			    <el-button type="primary" :disabled="!passForm.pass" @click="submitPass('passForm')">提交注册</el-button>
			  </el-form-item>
			</el-form>

			<!-- 注册成功 -->
			<div v-show="isSign" class="sign_success">
				<div class="main_word f20 tc mb10">注册成功~~</div>
				<p>您的登录帐号为：</p>
				<p>{{ emailForm.email }}</p>
				<p>{{ phoneForm.phone }}</p>
                <a href="/suppliers/index">
				    <el-button class="mt20" type="primary">立即登录</el-button>
                </a>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		data () {
			var checkPhone = (rule, value, callback) => {
        if (!value) {
          callback(new Error('手机号不能为空'));
        } else {
        	if (/^1[0-9]\d{9}$/.test(value) == false) {
        		callback(new Error('手机号格式不正确'));
        	} else {
        		callback();
        	}
        }
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
        	if (value.length < 8) {
        		callback(new Error('密码不能少于8位'));
        	} else if (value.length > 20) {
        		callback(new Error('密码不能大于20位'));
        	} else {
        		if (/^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{8,20}$/.test(value) == false) {
        			callback(new Error('请输入8-20位字母和数字组合'));
        		} else {
        			this.$refs.passForm.validateField('checkPass');
        			callback();
        		}
        	}
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.passForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
			return {
				seconds: 60, 					// 倒计时秒数
				btnTxt: '发送验证码',

				// 注册头部样式
				isPhoneAwait: true,		// 是否进入验证手机 （样式）
				isPasswordAwait: true,		// 是否进入设置密码 （样式）
				isDoneAwait: true,		// 是否进入完成注册 （样式）

				// 显示当前注册内容
				isEmail: true,
				isPhone: false,
				isPass: false,
				isSign: false,

				// 验证码按钮状态
				isCode: false,
				// 邮箱提示
				isTip: false,

				// 邮箱数据
				emailForm: {
				  icode: '',
				  email: ''
				},
				// 手机号数据
				phoneForm: {
					phone: '',
					icode: ''
				},
				// 密码数据
				passForm: {
					pass: '',
					checkPass: ''
				},
				// 验证密码
				rules: {
          pass: [
            { required: true, validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { required: true, validator: validatePass2, trigger: 'blur' }
          ]
        },
				// 验证手机规则
				rules2: {
					phone: [
						{ required: true, validator: checkPhone, trigger: 'blur' }
					]
				}
			}
		},
		methods: {
			// 发送验证码
			submitIcode (type,info) {
				var _this = this;
				var emailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
				var phoneReg = /^1[0-9]\d{9}$/;
				// 手机号验证码
				if (type) {
					if (phoneReg.test(info)) {
						// ajax
						// success if(data.status)
						$.post({
							url: '/suppliers/supplier/register/mobilePhone/send/code',
							data: {
								mobilePhone: info
							},
							success: function(result) {
								if (!result.code) {
									_this.isCode = true;
									// 倒计时
									_this.countDown();
								} else {
									_this.$message({
									  showClose: true,
									  message: result.msg,
									  type: 'error'
									});
								}
							}
						});
					} else {
						console.log("手机错误")
					}
				} else {
					// 邮箱验证码
					if (emailReg.test(info)) {
						// ajax
						$.post({
							url: '/suppliers/supplier/register/email/send/code',
							data: {
								email: info
							},
							success: function(result) {
								if (!result.code) {
									_this.isCode = true;
									_this.isTip = true;
									// 倒计时
									_this.countDown();
								} else {
									_this.$message({
									  showClose: true,
									  message: result.msg,
									  type: 'error'
									});
								}
							},
							error: function () {
								_this.$message({
									showClose: true,
									message: "网络错误",
									type: 'error'
								});
							}
						});
						// // success if(data.status)
						// this.isCode = true;
						// this.isTip = true;
						// // 倒计时
						// this.countDown();
						// console.log(info)
					} else {
						console.log("邮箱错误")
					}
				}
			},
			// 验证邮箱
			submitEmail(formName) {
				var _this = this;
				var email = this.emailForm.email;
				var code = this.emailForm.icode
        this.$refs[formName].validate((valid) => {
          if (valid) {
          	// ajax
          	$.post({
							url: '/suppliers/supplier/register/email/check/code',
							data: {
								email: email,
								code: code
							},
							success: function(result) {
								if (!result.code) {
									_this.isEmail = false;
			          	_this.isPhoneAwait = false;
			          	_this.isTip = false;
			          	_this.seconds = 0;
			          	setTimeout(function(){
			          		_this.isPhone = true;
			          	},400);
			          	setTimeout(function(){
			          		$('.getfocus input').focus();
			          	},401)
								} else {
									_this.$message({
									  showClose: true,
									  message: result.msg,
									  type: 'error'
									});
								}
							}
						});
            console.log(this.emailForm)
          } else {
            console.log('error submit!!');
            return false;
          }
        });
		  },
		  // 倒计时
		  countDown () {
		  	var _this = this;
		  	if (this.seconds == 0) {
		  		this.isCode = false;
		  		this.btnTxt = '发送验证码';
		  		this.seconds = 60;
		  		return;
		  	} else {
		  		this.isCode = true;
		  		this.btnTxt = this.seconds + '秒后重发';
		  		this.seconds--;
		  	}
		  	setTimeout(function(){
		  		_this.countDown();
		  	},1000)
		  },
		  // 验证手机
		  submitPhone (formName) {
		  	var _this = this;
		  	var mobilePhone = this.phoneForm.phone;
		  	var code = this.phoneForm.icode;
		  	this.$refs[formName].validate((valid) => {
          if (valid) {
            // alert('submit!');
            // ajax 
            $.post({
							url: '/suppliers/supplier/register/mobilePhone/check/code',
							data: {
								mobilePhone: mobilePhone,
								code: code
							},
							success: function(result) {
								if (!result.code) {
									_this.isPhone = false;
									_this.isEmail = false;
									_this.isPass = true;
									_this.isPasswordAwait = false;
								} else {
									_this.$message({
									  showClose: true,
									  message: result.msg,
									  type: 'error'
									});
								}
							}
						});
            
          } else {
            console.log('error submit!!');
            return false;
          }
        });
		  },
		  // 验证密码
		  submitPass (formName) {
		  	var _this = this;
		  	var password = this.passForm.pass;
		  	this.$refs[formName].validate((valid) => {
          if (valid) {
            // alert('submit!');
            // ajax
            $.post({
							url: '/suppliers/supplier/register',
							data: {
								password: password
							},
							success: function(result) {
								if (!result.code) {
									_this.isPass = false;
			            _this.isSign = true;
			            _this.isDoneAwait = false;
								} else {
									_this.$message({
									  showClose: true,
									  message: result.msg,
									  type: 'error'
									});
								}
							}
						});
            
          } else {
            console.log('error submit!!');
            return false;
          }
        });
		  }
		}
	}
</script>

<style type="text/css" lang="less" scoped>
	.sign_wrap {
	  width: 1042px;
	  height: 500px;
	  margin: 50px auto;
	  border: 1px solid #eee;
	}
	// 注册头部
	.email,
	.phone,
	.password {
		width: 260px;
		height: 46px;
		display: inline-block;
		// background-color: #ff4a7d;
		background: -webkit-linear-gradient(left, #fff1fa , #ffd5dc); /* Safari 5.1 - 6.0 */
		background: -o-linear-gradient(right, #fff1fa, #ffd5dc); /* Opera 11.1 - 12.0 */
		background: -moz-linear-gradient(right, #fff1fa, #ffd5dc); /* Firefox 3.6 - 15 */
		background: linear-gradient(to right, #fff1fa , #ffd5dc); /* 标准的语法 */

		position: relative;
		text-align: center;
		line-height: 46px;
		color: #FF4A7D;
	}
	.done {
		width: 258px;
		height: 46px;
		display: inline-block;
		// background-color: #ff4a7d;
		background: -webkit-linear-gradient(left, #fff1fa , #ffd5dc); /* Safari 5.1 - 6.0 */
		background: -o-linear-gradient(right, #fff1fa, #ffd5dc); /* Opera 11.1 - 12.0 */
		background: -moz-linear-gradient(right, #fff1fa, #ffd5dc); /* Firefox 3.6 - 15 */
		background: linear-gradient(to right, #fff1fa , #ffd5dc); /* 标准的语法 */

		position: relative;
		text-align: center;
		line-height: 46px;
	}
	.email:before,
	.phone:before,
	.password:before {
		border: solid transparent;
		content: '';
		width: 0;
		height: 0;
		left: 100%;
		position: absolute;
		border-width: 23px;
	    border-left-color: #ffd5dc;
	    top: 0;
	    z-index: 999;
	}
	.phone {
		left: -4px;
	}
	.password {
		left: -8px;
	}
	.done {
		margin-left: -12px;
		right: -1px;
	}
	.phone_await,
	.password_await,
	.done_await {
		background: #f9f9f9;
		color: #aaa;
		.circle_await {
			display: inline-block;
			width: 24px;
			height: 24px;
			border-radius: 50%;
			background-color: #e3e3e3;
			vertical-align: middle;
			text-align: center;
			line-height: 24px;
			margin-right: 4px;
			color: #fff;
		}
	}
	.phone_await:before,
	.password_await:before,
	.done_await:before {
		border-left-color: #f9f9f9;
	}
	.circle {
		display: inline-block;
		width: 24px;
		height: 24px;
		border-radius: 50%;
		background-color: #FF4A7D;
		vertical-align: middle;
		text-align: center;
		line-height: 24px;
		margin-right: 4px;
		color: #fff;
	}
	// 注册表单
	.sign_info {
		width: 460px;
		margin: 70px auto;
		position: relative;
	}
	.tip_wrod {
		width: 320px;
		margin-left: 98px;
	}
	.pass_tip {
		position: absolute;
		right: -155px;
		top: 8px;
		color: #aaa;
	}
	.sign_success {
		width: 460px;
		margin: 100px auto;
		text-align: center;
		p {
			line-height: 30px;
			color: #333;
		}
	}
</style>


// WEBPACK FOOTER //
// signup.vue?54971f07